import { useState, useEffect } from "react";
import Navbar from "./Navbar";
import data from "../utils/data/HERODATA.json";
import { Link } from "react-router-dom";

export default function Hero() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [visibleCardsIndex, setVisibleCardsIndex] = useState(0); // Index for the visible cards
  const [isSmallScreen, setIsSmallScreen] = useState(false); // Detect if screen is small
  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
      setIsMobileMenuOpen(false); // close mobile menu after navigation
    }
  };
  useEffect(() => {
    // Update the screen size check
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 640); // 640px as the breakpoint for mobile
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Initial check on load

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Change the visible cards every 5 seconds on small screens
  useEffect(() => {
    if (isSmallScreen) {
      const interval = setInterval(() => {
        setVisibleCardsIndex(
          (prevIndex) => (prevIndex + 2) % data.HERODATA.length
        ); // Loop through the cards in pairs of 2
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [isSmallScreen]);

  const blackBackgroundStyle = {
    backgroundColor: "black",
  };

  const defaultBackgroundStyle = {
    backgroundImage: `
      linear-gradient(to bottom, rgba(0, 0, 0, 0) 60%, #000000 100%),
      linear-gradient(0deg, rgba(27, 0, 115, 0.25), rgba(27, 0, 115, 0.25)),
      linear-gradient(180deg, rgba(0, 0, 0, 0) 84.94%, #000000 99.01%),
      url('/background_gif.gif')
    `,
  };

  return (
    <div
      id="coaler"
      className="min-h-screen bg-no-repeat bg-center bg-cover relative"
      style={isMobileMenuOpen ? blackBackgroundStyle : defaultBackgroundStyle}
    >
      <Navbar
        isMobileMenuOpen={isMobileMenuOpen}
        setIsMobileMenuOpen={setIsMobileMenuOpen}
      />

      {!isMobileMenuOpen && (
        <div className="max-w-[1380px] mx-auto text-white ">
          <div className="max-w-[1380px] min-h-[368px] mx-auto flex flex-col pt-[50px] gap-[50px] md:gap-[130px] items-center">
            <div className="flex flex-col max-w-[980px] gap-4 px-5 md:p-0 md:gap-8 text-center lg:text-left">
              <h1 className="font-900 md:font-extrabold text-[32px] md:text-4xl leading-tight">
                Revolutionizing the Coal Industry
              </h1>
              <p className="text-2xl leading-relaxed md:leading-[160%]">
                One Platform for Vendors, Transporters, and Buyers to connect,
                Trade, and Transport Seamlessly – Bringing Transparency and
                Efficiency to Coal Commerce.
              </p>
              <div
                className="rounded-full p-[5px] w-fit mx-auto lg:mx-0"
                style={{
                  backgroundImage: `linear-gradient(180deg, #F2F2F2 0%, #818181 41.42%, #FFFFFF 100%)`,
                  boxShadow: `
                    0px 39.52px 88.35px 0px #0000001A,
                    0px 160.42px 160.42px 0px #00000017,
                    0px 362.69px 218.54px 0px #0000000D,
                    0px 644px 258.06px 0px #00000003,
                    0px 1006.69px 281.31px 0px #00000000
                  `,
                }}
              >
                <div className="flex h-12 gap-3 items-center rounded-full pl-6 pr-[18px] pb-0.5 backdrop-blur-[42px] bg-[#f2f2f2]/90">
                  <span
                    onClick={() => scrollToSection("contact")}
                    className="font-bold text-[16px] md:text-[18px] text-black cursor-pointer"
                  >
                    Get Early Access
                  </span>
                  <button>
                    <img
                      src="/mingcute_right-fill.png"
                      alt=""
                      className="w-6 h-6"
                    />
                  </button>
                </div>
              </div>
            </div>

            {/* Stats Section */}
            <div className="text-sm flex flex-wrap justify-center gap-16">
              {isSmallScreen
                ? // Only on small screens, show 2 cards at a time
                  data.HERODATA.slice(
                    visibleCardsIndex,
                    visibleCardsIndex + 2
                  ).map((item, index) => (
                    <div
                      key={index}
                      className="w-[250px] text-center flex flex-col gap-2 animate-fade-in"
                      style={{
                        animationDelay: `${index * 0.5}s`, // Delay each card's animation slightly
                      }}
                    >
                      <h3 className="font-bold">{item.title}</h3>
                      <div className="h-0.5 max-w-[234px] rounded-[8px] bg-[linear-gradient(90deg,_rgba(116,12,128,0)_0%,_#B8A2FF_30%,_#B8A2FF_80%,_rgba(116,12,128,0)_100%)]"></div>
                      <p>{item.desc}</p>
                    </div>
                  ))
                : // For larger screens, show all cards without animation
                  data.HERODATA.map((item, index) => (
                    <div
                      key={index}
                      className="w-[290px] text-center flex flex-col gap-2"
                    >
                      <h3 className="font-bold text-lg">{item.title}</h3>
                      <div className="h-0.5 max-w-[280px] rounded-[8px] bg-[linear-gradient(90deg,_rgba(116,12,128,0)_0%,_#B8A2FF_30%,_#B8A2FF_80%,_rgba(116,12,128,0)_100%)]"></div>
                      <p>{item.desc}</p>
                    </div>
                  ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
